import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import { xszn } from './xszn';
import { czzn } from './czzn';
import { spxx } from './spxx';
import { cjwt } from './cjwt';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/xszn/rhgm',
    children: [
      xszn,
      czzn,
      spxx,
      cjwt,
    ],
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.afterEach(() => {
  document.title = '众可信e记账';
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
